import Vue from 'vue'
import Vuex from 'vuex'
import { baseUrl2 } from '@/static/utils/lyconfig'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    esriModule: null,
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : '',
    baseTreeData: [], //图层：底图图层
    dataTreeData: [],
    selectQueryData: [],
    timestamp: '',
    curCheckedLayerId: 0,
    allLayerData: [], //数据图层临时保存
    SingleData: null, //我的数据
    dataLoadedState: false, //任务数据加载完成情况
    clientToken: null,
    baseCheckedData: [],
    zoomEndTimestamp: '',
    dragParams: {
      //拖拽事件参数
      vectorLayerData: '',
      firstDragTimestamp: '',
      lastExtent: '',
      nowExtent: '',
      selectedAllData: '',
    },
    layerImages: [],
    arcLineArr: [],
    pageType: 'map',
    stopLoading: false, //是否停止加载地图数据
    drawingText: '',
    gispai_user: {
      userid: Number(localStorage.getItem('user-userId')),
    },
    baseLayerDraging: false, //地图图层拖拽中、。。。
    mapRightMenu: {
      type: 1,
      top: 0,
      left: 0,
      show: false,
      isEditing: false,
      isShowcopy: false,
      isShowpaste: false,
      ismove: false,
    }, //1:图形上右键菜单，2：任务图层上右键菜单，3：其它右键菜单
    activateMenu: '',
    activateMenuUrl: '',
    gisApi: localStorage.getItem('gisApi')
      ? JSON.parse(localStorage.getItem('gisApi'))
      : {
          gisUrl: 'https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/',
          cssUrl: 'https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/esri/css/esri.css',
        },
    measureUnit: {
      areaUnitVal: '平方米', //面积单位
      lengthUnitVal: '米', //长度单位
      MeasurePoint: [], //测量点
      MeasureType: '', //测量类型
      checkMeasure: false,
      checkMeasure_move: false,
      showSum: false,
      TotalLength: 0,
      TotalArea: 0,
      m_oldArea: 0,
      m_oldLength: 0,
    }, //测量单位
    MeasureResult: {
      flag: '',
      point: {
        x: 0,
        y: 0,
      },
      Length: 0, //长度
      Segment: 0, //线段
      SumLengths: 0, //总长度
      Perimeter: 0, //周长
      Area: 0, //面积
      SumPerimeters: 0, //总周长
      SumAreas: 0, //总面积
    }, //测量结果
    transformWkid: {
      val: 4326,
      key: 4326,
      label: '地理坐标',
    }, //经纬度坐标
    movePositon: [0, 0, 0, 0],
    keyCode: {}, //键盘事件
    selectQueryPaginaData: [], //切片分页id
    isResetTableSelected: false,
    openAttrOnRight: false,
    selectedPagination: [], //选择工具，分页
    layerAttrList: [], //右侧属性框属性信息
    fieldDefault: [], //右侧属性框属性预设值
    currentSelected: [],
    stateTagsList: [], //标签页数组
    patrolPointId: -1, // 打卡页面查看点详情id
    mousePosition: {}, //拾取打卡点时鼠标当前位置
    isWorker: true, //是否是工作人员
    editLayerOptions: [], //编辑工具条图层选项，
    selfTools: '', //自定义工具条
    isStartEditing: false, //编辑器是否开始编辑
    mapMiddleMenu: {
      show: false,
      type: 1, //中键
      absoluteXY: false, //绝对xy
      directionAngle: false, //方向角度
      vertical: false, //垂直
      level: false, //水平
      top: 0,
      left: 0,
      position: false, //位置信息
      x: 0,
      y: 0,
      isClear: false,
    },
    nodeObj: null, //节点对象
    //公开地图
    openMapId: null,
    operation: '当前无操作', //操作说明
    currentEditLayer: '', //当前编辑的图层
    IsSetEditlayer: false,
    editTableAttr: [], //属性表属性变化（数据增删）
    geometryBySelect: null,
    token: localStorage.getItem('user-token'),
    // 查看图片url
    imgUrl: `${baseUrl2}/api/File/ShowBigImage?token=${JSON.parse(localStorage.getItem('user-token'))}&isWorker=${
      localStorage.getItem('isWorker') == true || localStorage.getItem('isWorker') == 'true' ? 1 : 2
    }&id=`,
    imgUrl2: `${baseUrl2}/api/File/ShowImage?token=${JSON.parse(localStorage.getItem('user-token'))}&isWorker=${
      localStorage.getItem('isWorker') == true || localStorage.getItem('isWorker') == 'true' ? 1 : 2
    }&id=`,
    // 查看视频url
    videoUrl: `${baseUrl2}/api/File/ReadVideo?token=${JSON.parse(localStorage.getItem('user-token'))}&isWorker=${
      localStorage.getItem('isWorker') == true || localStorage.getItem('isWorker') == 'true' ? 1 : 2
    }&id=`,
    // 下载文件链接
    fileUrl: `${baseUrl2}/api/File/DownFilesStaff?token=${JSON.parse(localStorage.getItem('user-token'))}&isWorker=${
      localStorage.getItem('isWorker') == true || localStorage.getItem('isWorker') == 'true' ? 1 : 2
    }&id=`,
    tiledServiceQueryState: false,
    selectQueryState: false,
    isCanMove: false,
    catchNode: false, //捕捉节点
    isEraseAuto: false, //绘制面是否擦除
    continuousPoint: false, //连续绘制点
    continuousCircle: false, //连续绘制圆形
    IsShowMaterial: true, //是否开启图形数据
    scminZindex: 100,
    sucaiObjList: [],
    taskDataId: '',
    // 地图鼠标移入多边形信息
    polygonInfo: {},
    // 所有伐区信息
    allFellableInfo: [],
    isExpiry: false,
    // 所有图形信息（通用）
    allPolygonInfo: [],
    // 切片图层鼠标移入图层信息
    sliceCanvasInfo: {},
  },
  mutations: {
    setSliceCanvasInfo(state, val) {
      state.sliceCanvasInfo = val
    },
    setAllPolygonInfo(state, val) {
      state.allPolygonInfo = val
    },
    setIsExpiry(state, val) {
      state.isExpiry = val
    },
    setAllFellableInfo(state, val) {
      state.allFellableInfo = val
    },
    setPolygonInfo(state, val) {
      state.polygonInfo = val
    },
    setTaskDataId(state, val) {
      state.taskDataId = val
    },
    setsucaiObjList(state, val) {
      state.sucaiObjList = val
    },
    setSCminZindex(state, val) {
      state.scminZindex = val
    },
    // 开启关闭图形数据
    set_bzData(state, val) {
      state.IsShowMaterial = val
      let sucaiLayerDiv = document.querySelector('#sucaiLayerId')
      if (sucaiLayerDiv) {
        if (state.IsShowMaterial) {
          sucaiLayerDiv.style.display = ''
        } else {
          sucaiLayerDiv.style.display = 'none'
        }
      }
    },
    set_continuousCircle(state, val) {
      state.continuousCircle = val
    },
    set_continuousPoint(state, val) {
      state.continuousPoint = val
    },
    set_isEraseAuto(state, val) {
      state.isEraseAuto = val
    },
    set_catchNode(state, val) {
      state.catchNode = val
    },
    SET_MOVE(state, val) {
      state.isCanMove = val
    },
    set_selectQueryState(state, val) {
      state.selectQueryState = val
    },
    set_tiledServiceQueryState(state, val) {
      state.tiledServiceQueryState = val
    },
    set_fileUrl(state, val) {
      state.fileUrl = val
    },
    set_imageUrl(state, val) {
      state.imgUrl = val
    },
    set_imageUrl2(state, val) {
      state.imgUrl2 = val
    },
    set_videoUrl(state, val) {
      state.videoUrl = val
    },
    set_geometryBySelect(state, val) {
      state.geometryBySelect = val
    },
    set_TableAttr(state, val) {
      state.editTableAttr = val
    },
    set_IsSetEditlayer(state, val) {
      state.IsSetEditlayer = val
    },
    set_CurrentEditLayer(state, val) {
      state.currentEditLayer = val
    },
    set_operation(state, val) {
      state.operation = val
    },
    // 公开地图
    set_openMapId(state, val) {
      state.openMapId = val
    },
    set_nodeObj(state, val) {
      state.nodeObj = val
    },
    set_mapMiddleMenu(state, val) {
      state.mapMiddleMenu = val
    },
    set_isStartEditing(state, val) {
      state.isStartEditing = val
    },
    // 设置用户自定义的工具条
    setSelfTools: (state, val) => {
      state.selfTools = val
    },
    setEditLayerOption(state, val) {
      state.editLayerOptions = val
    },
    // 判断登录的是否工作人员
    set_isWorker(state, val) {
      state.isWorker = val
    },
    set_patrolPointId(state, val) {
      state.patrolPointId = val
    },
    set_mousePosition(state, val) {
      state.mousePosition = val
    },
    set_currentSelect(state, val) {
      state.currentSelected = val
    },
    setFiledDefault(state, val) {
      state.fieldDefault = val
    },
    setLayerAttrList(state, val) {
      state.layerAttrList = val
    },
    set_selectedPagination(state, val) {
      state.selectedPagination = val
    },
    set_openAttr(state, val) {
      state.openAttrOnRight = val
    },
    set_isResetTableSelected(state, val) {
      state.isResetTableSelected = val
    },
    set_selectQueryPaginaData(state, val) {
      state.selectQueryPaginaData = val
    },
    SET_KEYCODE(state, val) {
      state.keyCode = val
    },
    setMovePosition(state, val) {
      state.movePositon = val
    },
    set_transformWkid(state, val) {
      state.transformWkid = val
    },
    set_MeasureResult(state, val) {
      state.MeasureResult = val
    },
    setActivateMenu(state, val) {
      state.activateMenu = val
    },
    setActivateMenuUrl(state, val) {
      state.activateMenuUrl = val
    },
    setMapRightMenu(state, val) {
      state.mapRightMenu = val
    },
    SET_BASELAYERDRAGING(state, val) {
      state.baseLayerDraging = val
    },
    set_drawingText(state, val) {
      state.drawingText = val
    },
    SET_STOP_LOADING(state, val) {
      state.stopLoading = val
    },
    set_arcLineArr(state, val) {
      state.arcLineArr = val
    },
    SET_LayerSImage(state, val) {
      state.layerImages = val
    },
    set_dataTree(state, val) {
      state.dataTreeData = val
    },
    SET_DRAGPARAMS(state, val) {
      state.dragParams = val
    },
    SET_END_Timestamp(state, val) {
      state.zoomEndTimestamp = val
    },
    set_baseCheckedData(state, val) {
      state.baseCheckedData = val
    },
    set_clientToken(state, val) {
      state.clientToken = val
    },
    changeDataLoadState(state, val) {
      state.dataLoadedState = val
    },
    set_SingleData(state, val) {
      state.SingleData = val
    },
    setAllLayerData(state, val) {
      state.allLayerData = val
    },
    SET_CUREHECKLAYERID(state, val) {
      state.curCheckedLayerId = val
    },
    SET_Timestamp(state, val) {
      state.timestamp = val
    },
    set_selectQueryData(state, val) {
      state.selectQueryData = val
    },
    setBaseLayerTree(state, val) {
      state.baseTreeData = val
    },
    setEsriModule(state, val) {
      state.esriModule = val
    },
    set_user: (state, user) => {
      localStorage.setItem('user', JSON.stringify(user))
      state.user = user
    },
    remove_user: (state) => {
      state.user = ''
      localStorage.removeItem('user')
    },
    /**
     * 选择tag标签
     */
    mutationSelectTags(state, data) {
      let result = false
      for (let i = 0; i < state.stateTagsList.length; i++) {
        if (state.stateTagsList[i].url == data.url) {
          return (result = true)
        }
      }
      result === false ? state.stateTagsList.push(data) : ''
    },

    /**
     * 关闭tag标签
     */
    mutationCloseTag(state, data) {
      let result = state.stateTagsList.findIndex((item) => item.url === data.url)
      state.stateTagsList.splice(result, 1)
    },
    /**
     * tag设置为空
     */
    setTag(state, data) {
      state.stateTagsList = []
    },
  },
  actions: {
    setcontinuousCircle(context, val) {
      context.commit('set_continuousCircle', val)
    },
    setcontinuousPoint(context, val) {
      context.commit('set_continuousPoint', val)
    },
    setisEraseAuto(context, val) {
      context.commit('set_isEraseAuto', val)
    },
    setcatchNode(context, val) {
      context.commit('set_catchNode', val)
    },
    setCanMove(context, val) {
      context.commit('SET_MOVE', val)
    },
    setGeometryBySelect(context, val) {
      context.commit('set_geometryBySelect', val)
    },
    setIsSetEditlayer(context, val) {
      context.commit('set_IsSetEditlayer', val)
    },
    setCurrentEditLayer(context, val) {
      context.commit('set_CurrentEditLayer', val)
    },
    setOperation(context, val) {
      context.commit('set_operation', val)
    },
    setTimestamp(context, val) {
      context.commit('SET_Timestamp', val)
    },
    curCheckedLayerId(context, val) {
      context.commit('SET_CUREHECKLAYERID', val)
    },
    setSingleData(context, val) {
      context.commit('set_SingleData', val)
    },
    setclientToken(context, val) {
      context.commit('set_clientToken', val)
    },
    zoomEndTimestamp(context, val) {
      context.commit('SET_END_Timestamp', val)
    },
    dragParams(context, val) {
      context.commit('SET_DRAGPARAMS', val)
    },
    setDataTree(context, val) {
      context.commit('set_dataTree', val)
    },
    setLayerSImage(context, val) {
      context.commit('SET_LayerSImage', val)
    },
    setStopLoading(context, val) {
      context.commit('SET_STOP_LOADING', val)
    },
    setDrawingText(context, val) {
      context.commit('set_drawingText', val)
    },
    setBaseLayerDraging(context, val) {
      context.commit('SET_BASELAYERDRAGING', val)
    },
    setMeasureResult(context, val) {
      context.commit('set_MeasureResult', val)
    },
    setTransformWkid(context, val) {
      context.commit('set_transformWkid', val)
    },
    keyCode(context, val) {
      context.commit('SET_KEYCODE', val)
    },
  },
  modules: {},
})
